module.exports = __webpack_public_path__ + "static/media/textIcon.fdcd17c7.png";